var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep7Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 56,
    viewBox: "0 0 45 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.635 12.0759H8.57727C7.27127 12.0759 6.21191 13.1353 6.21191 14.4413V47.528C6.21191 48.835 7.27127 49.8933 8.57727 49.8933H30.9074L37.8948 42.4659V14.4413C37.8948 13.1353 36.8355 12.0759 35.5295 12.0759H30.4717",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 16.9051V12.0313C1 9.23572 3.26648 6.96924 6.06209 6.96924H13.7536",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.0364 55H6.06209C3.26648 55 1 52.7335 1 49.9379V20.4463",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30.3535 6.96924H38.045C40.8406 6.96924 43.1071 9.23572 43.1071 12.0313V49.9378C43.1071 52.7334 40.8406 54.9999 38.045 54.9999H33.9667",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.392 5.72408H27.6377C27.3149 5.72408 27.0452 5.48787 26.9916 5.16952C26.5924 2.80286 24.5339 1 22.0537 1C19.5735 1 17.5149 2.80286 17.1158 5.16952C17.0621 5.48776 16.7923 5.72408 16.4696 5.72408H15.7153C14.5182 5.72408 13.5479 6.69445 13.5479 7.89157V11.4669C13.5479 12.664 14.5182 13.6344 15.7153 13.6344H28.392C29.5891 13.6344 30.5595 12.664 30.5595 11.4669V7.89147C30.5595 6.69445 29.5891 5.72408 28.392 5.72408Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.8945 42.4658H33.579C32.1034 42.4658 30.9072 43.662 30.9072 45.1376V49.8938L37.8945 42.4658Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.9234 27.223H10.7899C10.4097 27.223 10.1016 26.9149 10.1016 26.5347V22.1546C10.1016 21.7744 10.4097 21.4663 10.7899 21.4663H14.9234C15.3036 21.4663 15.6117 21.7744 15.6117 22.1546V26.5347C15.6117 26.9149 15.3036 27.223 14.9234 27.223Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.1207 27.2232H19.9871C19.607 27.2232 19.2988 26.9151 19.2988 26.5349V19.8275C19.2988 19.4473 19.607 19.1392 19.9871 19.1392H24.1207C24.5009 19.1392 24.809 19.4473 24.809 19.8275V26.5349C24.809 26.9151 24.5009 27.2232 24.1207 27.2232Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.317 27.2232H29.1834C28.8033 27.2232 28.4951 26.915 28.4951 26.5349V17.2921C28.4951 16.9119 28.8033 16.6038 29.1834 16.6038H33.317C33.6972 16.6038 34.0053 16.9119 34.0053 17.2921V26.5349C34.0053 26.915 33.6972 27.2232 33.317 27.2232Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M19.3311 39.0377L20.7837 41.1157L24.775 36.0803",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M22.0531 45.3659C25.7909 45.3659 28.821 42.3358 28.821 38.598C28.821 34.8602 25.7909 31.8301 22.0531 31.8301C18.3153 31.8301 15.2852 34.8602 15.2852 38.598C15.2852 42.3358 18.3153 45.3659 22.0531 45.3659Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep7Icon);
export default __webpack_public_path__ + "static/media/step7-icon.90595d59912f13325b2419f2303f663c.svg";
export { ForwardRef as ReactComponent };